var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9174931,2.86418236 L3.54697982,1.23469564 C3.65960611,1.12206935 3.84172521,1.12206935 3.95315335,1.23469564 L4.2239357,1.50547799 C4.33656199,1.61810428 4.33656199,1.80022338 4.2239357,1.91165152 L3.07011533,3.0678682 L4.22513385,4.22288672 C4.33776014,4.33551301 4.33776014,4.51763212 4.22513385,4.62906025 L3.9543515,4.90104076 C3.84172521,5.01366704 3.65960611,5.01366704 3.54817797,4.90104076 L1.91869125,3.27155404 C1.80486681,3.15892775 1.80486681,2.97680864 1.9174931,2.86418236 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.48fbc3c010c8f0ef30bf267ada48e8f1.svg";
export { ForwardRef as ReactComponent };